import { CreateUserInput } from '@akin-home/amplify';
import { ContactModel } from '@akin-home/contacts';

export const getCreateUserInputFromContact = (
  contact: ContactModel,
  user_data: { sub: string; username: string }
): CreateUserInput => {
  return {
    name: contact.name,
    contact_id: contact.id,
    phoneNumber: contact.phoneNumbers?.[0]?.number,
    email: contact.emailAddresses?.[0],
    habitatID: contact.habitatID,
    profilePicture: contact.profilePicture,
    imageID: contact.image?.id,
    ...user_data,
  };
};
